import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { listUserQuotes } from '@/lib/quote';
import { useAuth } from './useAuth';
import type { Quote } from '@/types/Quote';

const QUOTES_KEY = (uid: string) => ['quotes', uid] as const;

export function useUserQuotes() {
  const { user } = useAuth();
  return useQuery({
    queryKey: QUOTES_KEY(user?.uid ?? 'anon'),
    queryFn: () => (user ? listUserQuotes(user.uid) : Promise.resolve([])),
    enabled: !!user,
    staleTime: 30_000,
  });
}

export function useQuote(quoteId: string | undefined) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['quote', user?.uid ?? 'anon', quoteId],
    queryFn: async () => {
      if (!user || !quoteId) return null;
      const snap = await getDoc(doc(db, 'users', user.uid, 'quotes', quoteId));
      if (!snap.exists()) return null;
      return { id: snap.id, ...snap.data() } as Quote;
    },
    enabled: !!user && !!quoteId,
    staleTime: 60_000,
  });
}
